import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { getReportTimeStamp } from "../../Utils/Utils";

export const exportToExcel = async (data) => {
  const { rows, columns, name, header } = data; // Accept a header parameter
  const nameWithTimestamp = getReportTimeStamp(name)

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("My Data");

  let currentRow = 1; // Start row tracking

  // Add a custom header row if provided
  if (header) {
    const lastColumnLetter = String.fromCharCode(64 + columns.length);
    const mergedRange = `A${currentRow}:${lastColumnLetter}${currentRow}`;
    worksheet.mergeCells(mergedRange);
    const headerCell = worksheet.getCell(`A${currentRow}`);
    headerCell.value = header;
  
    worksheet.getRow(currentRow).eachCell((cell) => {
      cell.font = { name: "Arial", size: 26, bold: true }; // Apply to all cells in the row
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    });
    const headerRow = worksheet.getCell(`A${currentRow}`);
    headerRow.font = { name: "Arial", size: 16, bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };

// Apply to all cells in the merged range
worksheet.getRow(currentRow).eachCell((cell) => {
  cell.font = { name: "Arial", size: 16, bold: true };
});

  }

  console.log("font here ---> ",worksheet.getCell(`A1`).font);

    // Add column headers
  worksheet.addRow(columns.map((col) => col.header));
  const headerRow = worksheet.getRow(currentRow);
  headerRow.font = { name: "Arial", bold: true };
  headerRow.alignment = {
    vertical: "middle",
    horizontal: "center",
  };
  currentRow += 1; // Move to the next row for data rows

  // Add data rows with "N/A" handling except for the last row
  rows.forEach((rowData, index) => {
    const row =
      index === rows.length - 1 // Check if it's the last row
        ? columns.map((col) => rowData[col.key]) // Leave values as they are
        : columns.map((col) => {
            const value = rowData[col.key];
            return value === null || value === undefined || value === "" ? "N/A" : value; // Replace missing values with "N/A"
          });
    worksheet.addRow(row);
  });

  // Apply formatting to all cells
  worksheet.columns = columns.map((col) => ({
    key: col.key,
    width: col.width || 15, // Default width if not provided
  }));
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.font = { name: "Arial", size: 12 };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // Generate Excel file and save
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, nameWithTimestamp);
};
